import { PageRendererProps } from 'gatsby';
import React from 'react';
import { navigate } from 'gatsby-plugin-intl';
import { useKeycloak } from '@react-keycloak/web';
import { AuthConstants } from '../../utils/constants/AuthConstants';
import { isLoggedIn, setToken } from '../../services/AuthService';
import BrowserHelper from '../../utils/helpers/BrowserHelper';

export const PrivateRoute: React.FC<PageRendererProps> = (props) => {
  const { keycloak } = useKeycloak();
  const { children } = props;

  if (keycloak.authenticated) {
    if (!isLoggedIn()) {
      const token = BrowserHelper.getSessionStorageItem(AuthConstants.USER_TOKEN) || keycloak.token;
      if (token !== undefined && token.length > 0) {
        setToken(token);
        navigate('/');
        return null;
      }
    }
    return <>{children}</>;
  }
  navigate('401');
  return null;
};

export default PrivateRoute;
